/* @flow */

import React from 'react';
import IconHeader from 'shared/components/IconHeader';

const Header = () => <IconHeader icon="tablet" circular title="Application" />;

export default Header;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Header.js